<template>
  <div>
    <div v-if="isLoading">Loading...</div>
    <div v-if="!isLoading && item">
      <button class="snipcart-add-item"
        :data-item-id="item.id"
        :data-item-price="item.Price"
        :data-item-description="item.Description || ''"
        :data-item-image="item.Image || ''"
        :data-item-name="item.Title">
				{{ item.Title }}
      </button>
    </div>
    <div v-if="!isLoading && !item">
      <p>Item not found</p>
    </div>
  </div>
</template>

<script>
import { products, extras, upsells } from '@/agent';

export default {
  name: 'product-data',

  data() {
    return {
      item: null,
      isLoading: true,
    };
  },

  async mounted() {
    const itemId = this.$route.params.id;
    if (itemId) {
      // Try to fetch as product first, then extras, then upsells
      this.item = await products.findById(itemId);
      if (!this.item) {
        this.item = await extras.findById(itemId);
      }
      if (!this.item) {
        this.item = await upsells.findById(itemId);
      }
    }
    this.isLoading = false;
  },
};
</script>
